<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title class="text-h5">
          Ändra buntnummer
        </v-card-title>
        <v-card-subtitle>
          <v-row>
            <v-col sm="2">
              <v-text-field v-model="customerId" 
                            outlined
                            label="Kundnummer"
                            type="number"                                               
                            class="input" 
                            @keyup.enter="search()"
              >
                <template v-slot:append-outer>
                  <v-btn icon 
                         @click="search()"
                  >              
                    <v-icon>mdi-magnify</v-icon>                              
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
              
            <v-col sm="1" class="mt-3">
              <v-btn class="warning"
                     @click="reset"
              >
                Rensa
              </v-btn>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-data-table       
            :headers="headers"
            :items="bundles"
            :items-per-page="10"
            :loading="loading"
            loading-text="Laddar buntar"
            class="elevation-1"
          >           
            <template v-slot:item.type="{ item }">
              <span>{{ paperTypes[item.type] }}</span>
            </template>
            <template v-slot:item.open="{ item }">
              <span v-if="item.open">Öppen</span>
              <span v-else>Stängd</span>
            </template>
            <template v-slot:item.newBundleNumber="{ item }">
              <v-text-field v-model="item.newBundleNumber" />               
            </template>
            <template v-slot:item.actions="{ item }">                      
              <v-icon
                small
                @click="update(item)"
              >
                mdi-content-save
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import api from '@/backend/adminapi'
import log from '@/logger'
import * as pt from '@/model/paperTypes'
export default{
    name:'BundleChangeNumber',
    data(){
        return{           
            paperTypes: pt.types,
            bundles: [],    
            loading: false,
            customerId: undefined,  
            headers: [
              { text: 'Bunt nummer', align: 'start', value: 'id' },
              { text: 'Status', value: 'open' },              
              { text: 'Typ', value: 'type' },              
              { text: 'Nytt nummer', value: 'newBundleNumber' },              
              { text: '', value: 'actions', sortable: false },
            ],            
        }
    },

    computed:{
            
    },
    watch: { 
      customerId: function() { // watch it          
         this.bundles = []        
         this.loading = false              
      },      
    },
    mounted() {        
      
    },
    methods: {  
        search(){
          this.loadData()  
        },
        reset(){
          this.customerId = undefined
      
        },
        loadData() {
            this.loading = true
            let self= this
            api.adminGetChangeableBundles(this.customerId)
            .then((resp) => {
                this.bundles = resp.data
                this.bundles.forEach(obj => {
                  obj['newBundleNumber']                 
                  obj['error']  
                })
                self.loading = false
                log.debug('Bundles:' + resp.data)                
            }).catch((error) => {
                self.loading = false
                log.debug('Error getting bundles:', error)
            })            
        },
        update(item){
            log.debug('Change ' + item.id + ' to '+ item.newBundleNumber)            
            api.adminChangeBundle(this.customerId, item)
            .then((resp) => {
                this.loadData()                
                self.loading = false
                log.debug('Bundles:' + resp.data)                
            }).catch((error) => {
                self.loading = false
                if(error.response.status === 400){                   
                    item.error = [error.response.data.error]                    
                    alert(item.error)
                }
                log.debug('Error updating bundle.', error)
            })            
        },
        clearErrorMessage(item){
            item.error === undefined
        }

    }

}
</script>
<style scoped>
span {
    font-size: 1em;
}

.input >>> input[type="number"] {
  appearance: textfield;  
  -moz-appearance: textfield;  
}
.input >>> input::-webkit-outer-spin-button,
.input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>